// extracted by mini-css-extract-plugin
export default {"designPageButtonContainer":"Design_designPageButtonContainer__9iAap","designPageButton":"Design_designPageButton__viLIO"};